import { useState } from "react";
import QuestionModalAnswer from "./QuestionModalAnswer";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faCircleCheck,
  faCircleXmark,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { Loader } from "../../../../MainComponents";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import HelmetTags from "../../../../MainComponents/HelmetTags";

const AdminModalAnswer = ({ exam }) => {
  const [collapse, setCollapse] = useState(false);
  const [activeQuestionId, setActiveQuestionId] = useState(0);
  const { examID } = useParams();
  const navigate = useNavigate();

  const api = process.env.REACT_APP_ADMIN_TRIAL_EXAM_VIEW_MODEL_ANSWER_API;

  const [modalAnswerData, modalAnswerErrors, modalAnswerLoading] = useAxios(
    `${api}${examID}`,
    "GET",
    "GET",
    ""
  );

  function handleOnClickQuestion(id) {
    handelOpenCollapse();
    setActiveQuestionId(id);
  }

  function handelOpenCollapse() {
    setCollapse(true);
  }

  function handelCloseCollapse() {
    setCollapse(false);
  }

  if (modalAnswerLoading) return <Loader />;
  return (
    <section className="h-full w-full overflow-y-auto px-20 py-20 sm:px-10 ">
      <HelmetTags title="Model Answer | Nash Academy "></HelmetTags>
      <h2 className="mb-20 w-full  text-4xl font-bold md:text-center">
        Student Model Answer
      </h2>
      <QuestionModalAnswer
        collapse={collapse}
        onCloseCollapse={handelCloseCollapse}
        activeQuestionId={activeQuestionId}
        question={modalAnswerData?.data[activeQuestionId]}
      />
      <div className="all-questions flex h-full flex-col items-center  transition-all  duration-300 ease-in-out w-full md:order-2 md:w-full">
        {modalAnswerErrors && (
          <div className="flex justify-center flex-col">
            <p>{modalAnswerErrors}</p>
            <button
              onClick={() => navigate(-1)}
              className="flex justify-center my-6"
            >
              <div className="collapse-btn top-[96px] flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-full bg-accent text-light shadow-md shadow-black/40 duration-300 hover:scale-110 hover:text-light">
                <FontAwesomeIcon
                  className={`transition-all duration-300 ease-in-out hover:scale-110`}
                  icon={faChevronRight}
                />
              </div>
            </button>
          </div>
        )}
        {!modalAnswerLoading && !modalAnswerErrors && (
          <>
            <div
              className={`response-questions myactual-questions-container my-[40px] ${
                !modalAnswerData?.paragraph?.paragraph && "w-full"
              }`}
            >
              <div className="flex gap-5 w-full">
                {modalAnswerData?.paragraph?.paragraph && (
                  <p
                    className="flex-1 bg-white rounded-2xl h-[90vh] overflow-y-auto"
                    dangerouslySetInnerHTML={{
                      __html: modalAnswerData?.paragraph?.paragraph,
                    }}
                  />
                )}
                <div className="bg-white rounded-2xl  flex-1 h-[90vh] w-full overflow-y-auto py-10 px-3">
                  {modalAnswerData?.data?.map((question, index) => (
                    <div
                      key={index}
                      className="paragraphe modal-answer singleQuestionWrapper rounded-2xl bg-white mb-4"
                    >
                      <div className="optionsQuestionWrapper current-question flex-col !gap-0">
                        <div className="categoryQuestionWrapper">
                          {`${index + 1}.`}
                          <div
                            dangerouslySetInnerHTML={{
                              __html: question?.question,
                            }}
                          />
                        </div>
                        <div className="current-question-degree w-full flex justify-end">
                          <p> {question?.degree} degree</p>
                        </div>
                      </div>
                      <div className="categoryAnswersWrapper current-question-answers">
                        {question?.answers.map((answer, i) => (
                          <div
                            key={i}
                            className={`categorySingleAnswer answer1Wrapper
                            ${
                              question.correct_answer !==
                                question.student_answer &&
                              answer.order === question.student_answer &&
                              "none-selected"
                            }

                            ${
                              answer.order === question.correct_answer &&
                              "selected"
                            }`}
                          >
                            <span>{answer.order} </span>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: answer.answer,
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="indicators flex w-full items-center justify-center gap-[20px] border-t-2 border-t-light py-[20px] sm:flex-col">
              <div className="correct flex items-center gap-[8px] justify-self-center text-[18px] text-lime-500">
                <FontAwesomeIcon icon={faCircleCheck} />
                <p>Correct Answer</p>
              </div>
              <div className="correct flex items-center gap-[8px] justify-self-center text-[18px] text-accent">
                <FontAwesomeIcon icon={faCircleXmark} /> <p>Wrong Answer</p>
              </div>
              {/* <div className="correct flex items-center gap-[8px] justify-self-center text-[18px] text-amber-400">
                <FontAwesomeIcon icon={faSpinner} spinPulse />{" "}
                <p>Waiting for correction</p>
              </div> */}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default AdminModalAnswer;
